import { format, isValid } from "date-fns";
import { ptBR } from "date-fns/locale";

/**
 * Formata uma data no formato local com detalhes.
 * @param date - Data no formato 'YYYY-MM-DD' ou um objeto do tipo Date
 * @returns Um objeto contendo a data formatada em várias representações
 */
export const getFormattedDateDetails = (date: string | Date) => {
  let parsedDate: Date;

  if (typeof date === "string") {
    const [year, month, day] = date.split("-").map(Number);
    parsedDate = new Date(year, month - 1, day);
  } else if (date instanceof Date) {
    parsedDate = date;
  } else {
    return { error: "Formato de data inválido" };
  }

  if (!isValid(parsedDate)) {
    return { error: "Data inválida" };
  }

  return {
    fullDate: format(parsedDate, "dd/MM/yyyy", { locale: ptBR }),
    day: format(parsedDate, "dd", { locale: ptBR }),
    dayShort: format(parsedDate, "EEE", { locale: ptBR }),
    dayFull: format(parsedDate, "EEEE", { locale: ptBR }),
    month: format(parsedDate, "MM", { locale: ptBR }),
    monthShort: format(parsedDate, "MMM", { locale: ptBR }),
    monthFull: format(parsedDate, "MMMM", { locale: ptBR }),
    year: format(parsedDate, "yyyy", { locale: ptBR }),
  };
};
